var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('ekko-header-nav'),_c('router-view',{attrs:{"id":"why-ekko","name":"hero"}}),_c('router-view',{staticClass:"main-content",attrs:{"name":"content"}}),_c('router-view',{attrs:{"name":"footer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }